import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Layout, { BookingLink } from "../components/Layout";
import SEO from "../components/SEO";

export default function About() {
  return (
    <Layout>
      <SEO title="About Brandon Winston | Driver Reborn Advisory" description="Brandon Winston is the founder of Driver Reborn Advisory — a second-generation trucking professional with more than 20 years of hands-on industry experience." />
      <section className="section">
        <div className="container-narrow max-w-4xl">
          <div>
            <div className="text-[#FF6A00] text-xs uppercase tracking-widest mb-2">About</div>
            <h1 className="font-bebas text-5xl sm:text-6xl uppercase leading-none mb-6" data-testid="about-title">
              Brandon Winston
            </h1>
            <div className="text-[#E6E6E6] leading-relaxed space-y-5 mb-10" data-testid="about-bio">
              <p>
                Driver Reborn Advisory was founded by Brandon Winston, a second-generation trucking professional with more than 20 years of hands-on industry experience.
              </p>
              <p>
                Brandon grew up learning the business from his father, who spent more than 30 years as a professional driver and truck owner. His father drove cross-country, operated cement trucks, hauled flatbed and heavy-haul freight, and eventually specialized in piggyback transportation. He also studied accounting and taught Brandon to think beyond driving — to understand business finances, taxes, operating decisions, and the responsibility that comes with owning trucks. His father's trucking career ended in 2014 after he lost his eyesight, but the lessons he passed down remain part of Brandon's foundation today.
              </p>
              <p>
                Brandon followed his father into trucking but intentionally chose a different career path. After watching how much of his father's life was spent on the road, Brandon made a commitment to remain present for his own children. He built a successful local and regional driving career, rarely staying away longer than three days, while earning close to the six-figure level and remaining actively involved with his family.
              </p>
              <p>
                His experience eventually expanded beyond the driver's seat into instruction, training, recruiting, retention, dispatch conversations, management, transportation operations, and operational problem-solving.
              </p>
              <p>
                Throughout his career, Brandon became increasingly fascinated by the business behind the trucks. He studied the patterns separating companies that operated with financial clarity and control from those that kept their owners trapped in constant reaction. Although he understood truck ownership and had support available if he chose that route, he realized his greater purpose was not simply owning trucks — it was helping fleet owners build stronger businesses behind them.
              </p>
              <p>
                That combination of second-generation trucking knowledge, hands-on experience, family-centered decision-making, and operational pattern recognition became the foundation of Driver Reborn Advisory.
              </p>
              <p>
                Today, Brandon helps established fleet owners uncover profit leaks, strengthen their backend systems, better understand their numbers, reduce owner dependency, and build companies capable of moving from survival to structure, scale, and eventual exit-readiness.
              </p>
              <p className="text-[#FF6A00] font-bebas text-2xl uppercase tracking-wider">
                Driver Reborn Advisory was not created from the outside looking in. It was built from a lifetime around the people, pressure, numbers, equipment, and decisions that keep trucking companies moving.
              </p>
            </div>
            <div className="border-l-4 border-[#FF6A00] bg-[#111111] p-6 mb-8" data-testid="about-belief">
              <div className="text-[#FF6A00] text-xs uppercase tracking-widest mb-2">Driver Reborn Advisory's operating belief</div>
              <p className="font-bebas text-2xl uppercase leading-tight text-[#E6E6E6]">
                Clarity creates control. Control creates options. And a business should ultimately create freedom — not become another job the owner cannot leave.
              </p>
            </div>
            <BookingLink testid="about-cta">
              Request a 20-Minute Fleet Owner Conversation <ArrowRight size={20}/>
            </BookingLink>
          </div>
        </div>
      </section>
    </Layout>
  );
}
